export const attachmentExtensions = [
    "avi",
    "mov",
    "mkv",
    "wmv",
    "mp4",
    "mpg",
    "mpeg",
    "m4v",
    "3gp",
    "mov",
    "swf",
    "flv",
    "vob",
    "html",
    "htm",
    "pdf",
    "txt",
    "xls",
    "xlsx",
    "doc",
    "docx",
    "rtf",
    "csv",
    "pps",
    "ppt",
    "pptx",
    "xml",
    "bmp",
    "jpg",
    "jpeg",
    "png",
    "tif",
    "tiff",
    "svg",
    "gif"
]